module.exports = __webpack_public_path__ + "static/media/icon-basin.13de225a.svg";